import { Image, StyleSheet } from 'react-native';
import Colors from '../../constants/Colors';
import { Text, View } from '../Themed';
import Logo from '../../../assets/images/snapcalorie-logo-gray-65x65.png';

type LinkMapType = Record<string, undefined | (() => void)>;

export default function SiteHeader({ linkMap }: { linkMap?: LinkMapType }) {
  return (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        <View style={styles.logo}>
          <Image source={Logo} style={{ width: 65, height: 65 }} />
          <Text style={styles.title}>SnapCalorie</Text>
        </View>
        <View style={styles.separator} />
      </View>
      {linkMap && (
        <View style={styles.headerNav}>
          {Object.keys(linkMap).map((key) => {
            return (
              <Text key={`header_link_${key}`} style={styles.link} onPress={linkMap[key]}>
                {key}
              </Text>
            );
          })}
        </View>
      )}
    </View>
  );
}
SiteHeader.defaultProps = {
  linkMap: [],
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  headerContainer: {
    marginTop: 10,
    marginBottom: 10,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerNav: {
    width: 300,
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  link: {
    fontSize: 16,
    color: Colors.snapCalorie.linkColor,
    fontFamily: 'Poppins, Montserrat, "Helvetica Neue", Helvetica, Arial, sans-serif;',
  },
  logo: {
    flexDirection: 'row',
    margin: 10,
    alignItems: 'center',
  },
  separator: {
    borderBottomWidth: 3,
    borderBottomColor: Colors.snapCalorie.orange,
    width: 350,
    height: 3,
  },
  title: {
    fontSize: 40,
    padding: 10,
    color: Colors.snapCalorie.linkColor,
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontFamily: 'Poppins, Montserrat, "Helvetica Neue", Helvetica, Arial, sans-serif',
  },
});
